var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download_3_",
    "data-name": "download (3)",
    d: "M214.876,172.116c-2.2.561-3.043,1.415-3.651,3.23.264-1.9.159-7.128-6.482-9.611,1.191,3.5,1.164,8.97-.847,10.6.635-2.162-1.058-4.031-2.7-5.393.953,5.58-5.794,6.567-3.228,13.616a8.514,8.514,0,0,0,4.842,4.645c-1.4-3.738,1.878-8.81,4.233-9.878-.714,1.789.82,4.459,1.773,5.072a2.4,2.4,0,0,1,.582-2.67c.185,2.8,4.207,4.165,2.619,8.009a7.847,7.847,0,0,0,5.265-6.3c.794-4.351-3.413-7.715-2.407-11.32Z",
    transform: "translate(-197.383 -165.735)",
    fill: "#6699c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurned);
export default __webpack_public_path__ + "static/media/burned.12c2f6e55bd8ca20cdc52f90719e11e9.svg";
export { ForwardRef as ReactComponent };